import React, { useState } from "react";
import classNames from "classnames";
import { CaptureInteractions } from "@design-system/CaptureClicks/CaptureInteractions";
import { Input as BaseInput } from "@base-ui/react/input";
import { OptionGroupItem } from "./OptionGroupItem";
import styles from "./OptionGroup.module.scss";

interface OptionGroupCustomItemProps {
    value: string;
    empty: string;
    onChange(value: string): void;
    className?: string;
    disabled?: boolean;
}

export const OptionGroupCustomItem: React.FC<OptionGroupCustomItemProps> = ({
    value,
    empty,
    onChange,
    disabled,
    className,
}) => {
    const [editing, setEditing] = useState(false);

    return (
        <OptionGroupItem
            className={classNames(styles.customItem, className, {
                [styles.disabled]: disabled,
            })}
            title={value || empty}
            onToggle={() => !disabled && setEditing(true)}
        >
            {!disabled && editing ? (
                <CaptureInteractions className={styles.customItemEditor}>
                    <BaseInput
                        type="text"
                        className={styles.customItemInput}
                        value={value}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                        onBlur={() => setEditing(false)}
                        ref={(el) => el?.focus()}
                    />
                </CaptureInteractions>
            ) : null}
        </OptionGroupItem>
    );
};
